module.exports = __webpack_public_path__ + "img/EZ-Self-1.d128df6a.png";